export default {
  "name": "Two Lines Don't Converge",
  "slug": "two-lines-dont-converge",
  "path": "/two-lines-dont-converge",
  "componentName" : "TwoLinesDontConverge",
  "category": "Projects",
  "parent": "Perspective Lessons",
  "isPublic": true
}